import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import setTableCellType from 'utils/setTableCellType';

const LeadInfoModal = (props) => {
  const { open, setOpen, data, setData } = props;
  const { t } = useTranslation();

  const headCells = [
    { code: 'lead_name', label: t('lead.view.name') },
    { code: 'date', label: t('common.fields.date') },
    { code: 'block', label: t('common.filter.crm_block_item_id') },
    { code: 'staff', label: t('common.fields.staff') },
  ];
  const columns = [
    { code: 'lead_name' },
    { code: 'date', type: 'date' },
    { code: 'block' },
    { code: 'staff' },
  ];

  const handleClose = () => {
    setOpen(false);
    setData({});
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[75vw]',
      }}
    >
      <DialogTitle id='alert-dialog-title' className='!mb-5 !bg-[#CDCDCDC7]'>
        <div className='flex justify-center items-center gap-2'>
          {data?.color ? (
            <div
              className={`min-w-[18px] mr-1 h-[18px] border-4 rounded-full`}
              style={{ borderColor: data?.color }}
            />
          ) : (
            <></>
          )}
          <span className='mr-4'>{data?.name}</span>
        </div>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper h-[calc(100vh-180px)]'>
          <TableContainer
            className='tab-table-container !shadow-none !base-border'
            component='div'
          >
            <Table stickyHeader component='div'>
              <TableHead component='div'>
                <TableRow component='div'>
                  {headCells?.map((cell, i) => (
                    <TableCell key={i} align={'left'}>
                      {cell?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {data?.events?.length > 0 ? (
                <TableBody
                  className='overflow-hidden !bg-white'
                  component='div'
                >
                  {data?.events?.map((row, rowIndex) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={'row-' + rowIndex}
                        className='no-underline'
                        component={Link}
                        to={`/admin/crm/lead/edit/${row?.id}`}
                      >
                        {columns.map((column, columnIndex) => (
                          <TableCell
                            align={'left'}
                            key={'column-' + columnIndex}
                          >
                            {column?.code == 'status' ? (
                              t('boss.crm.general.active')
                            ) : column.type ? (
                              setTableCellType(column, row[column.code], row)
                            ) : column.code == 'lead_name' ? (
                              <Link
                                className='no-underline text-blue-500'
                                to={`/admin/crm/lead/edit/${row?.id}`}
                              >
                                {row[column.code]}
                              </Link>
                            ) : (
                              row[column.code]
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </TableBody>
              ) : (
                <TableBody component='div'>
                  <TableRow component='div'>
                    <TableCell colSpan={6}>
                      <span className='text-gray-400 flex items-center justify-center'>
                        <i className='bi bi-exclamation-octagon text-xl leading-4 mr-1' />{' '}
                        {t('common.global.noDataFound')}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(LeadInfoModal);
